import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@welldev-group/rcl-icon';
import IconButton from '@welldev-group/rcl-icon-button';
import { I18nText } from '@welldev-group/react-comp-lib';
import WorkspaceTableText from './WorkspaceTableText';
import WorkspaceTag from '../WorkspaceTag';
import WorkspaceCard from '../WorkspaceCard';

const WorkspaceTableRow = ({
  workspace,
  index,
  toggleDeletable,
  toggleEditable,
  actionDisabled,
}) => {
  return (
    <WorkspaceCard>
      <div className="col-3 workspace-table__name-field">
        <WorkspaceTag acronym={workspace.acronym} workspaceIndex={index} />
        <WorkspaceTableText
          title={workspace.name}
          label={<I18nText id="workspace.table.label.name" />}
        />
      </div>
      <div className="col-1 workspace-table__center-field">
        <WorkspaceTableText
          title={workspace.currency}
          label={<I18nText id="workspace.table.label.currency" />}
        />
      </div>
      <div className="col-3 workspace-table__center-field">
        <WorkspaceTableText
          title={workspace.identifier}
          label={<I18nText id="workspace.table.label.identifier" />}
        />
      </div>
      <div className="col-3 workspace-table__url-field">
        <WorkspaceTableText
          withLink={workspace.agentUrl}
          label={<I18nText id="workspace.table.label.url" />}
        />
      </div>
      <div className="col-2 align-self-center workspace-table__actions-field workspace-table__actions-field--position">
        <IconButton
          icon={<Icon name="edit" />}
          size="large"
          onClick={() => toggleEditable(index, true)}
          version="v2"
          standalone={true}
          label={<I18nText id="workspace.table.edit" />}
          disabled={actionDisabled}
        />
        <IconButton
          icon={<Icon name="delete" />}
          size="large"
          onClick={() => toggleDeletable(index, true)}
          version="v2"
          standalone={true}
          label={<I18nText id="workspace.table.delete" />}
          disabled={actionDisabled}
        />
      </div>
    </WorkspaceCard>
  );
};

WorkspaceTableRow.defaultProps = {
  actionDisabled: false,
};

WorkspaceTableRow.propTypes = {
  workspace: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    identifier: PropTypes.string.isRequired,
    acronym: PropTypes.string.isRequired,
    agentUrl: PropTypes.string.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  toggleDeletable: PropTypes.func.isRequired,
  toggleEditable: PropTypes.func.isRequired,
  actionDisabled: PropTypes.bool,
};

export default WorkspaceTableRow;
